import type { NextPage } from 'next';
import dynamic from 'next/dynamic';

import type { Props } from 'nextjs/getServerSideProps/handlers';

const StakingPageClient = dynamic(() => import('ui/pages/Staking'), {
  ssr: false,
});

const Page: NextPage<Props> = (props) => {
  return <StakingPageClient { ...props }/>;
};

export default Page;
